<template>
  <div class="content container">
    <h2 class="text-center">Über mich</h2>

    <hr>

    <p class="lead text-center content-highlight">
      Psychologische Psychotherapeutin, Verhaltenstherapie
    </p>

    <p class="lead text-center">
      für Erwachsene, Kinder und Jugendliche
    </p>

    <br>

    <div class="row">
      <div class="col-lg-6">
        <h4 class="text-center">Arbeitserfahrungen</h4>
        <ul>
          <li> Seit 2020 Niederlassung in eigener Praxis</li>
          <li> Seit 2019 Nebentätigkeit in einer Praxis mit Privatpatienten</li>
          <li>2018 – 2020 in Eltern(teil)zeit mit 2 Kindern</li>
          <li>2016 – 2018 Psychologische Psychotherapeutin im MVZ Unterhaching</li>
          <li>2015-2016 Psychologin in der Erziehungsberatungsstelle der AWO</li>
          <li>2012-2015 Gruppenübergreifender psychologischer Fachdienst bei Just M (Stadt München)
            mit unbegleiteten minderjährigen Flüchtlingen
          </li>
          <li>2012 – 2015 Mitarbeit in psychotherapeutischer Lehrpraxis</li>
          <li>2011-2012 Psychologin in Ausbildung im Bezirkskrankenhaus in Haar</li>
        </ul>
      </div>
      <div class="col-lg-6">

        <h4 class="text-center">Bildung</h4>
        <ul>
          <li>2016 Approbation und Arztregistereintrag</li>
          <li>Seit 2015 Kinder und Jugendzusatzausbildung (KJP – VT) am Centrum für integrative
            Psychotherapie
          </li>
          <li>2012 – 2016 Ausbildung zur psychologischen Psychotherapeutin am Centrum für integrative
            Psychotherapie
          </li>
          <li>2005 – 2010 Studium der Psychologie an der Universität Marburg und in Lima, Peru</li>
        </ul>

        <div class="portrait-image">
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'ContentAboutMe',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding-top: 20px;
}

.portrait-image {
  /*float: right;*/
  background-image: url("../assets/swenja-portrait-bw.web.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 265px;
  /*margin-left: 20%;*/
  /*margin-right: 20%;*/
}

</style>
